import React from "react";

import stop_request from "@/assets/images/ai/button/stop_request.png";

import "./index.less";

export default function ActionTools(props: {
  children?: React.ReactNode;
  showAbortButton: boolean;
  onAbort?: () => void;
}) {
  const { children, showAbortButton } = props;

  return (
    <div className="chat-action-tools">
      {children}
      {showAbortButton && (
        <div className="chat-action-tools__abort" onClick={props.onAbort}>
          <img className="chat-action-tools__abort-icon" src={stop_request} alt="" />
          <div className="chat-action-tools__abort-text">停止回答</div>
        </div>
      )}
    </div>
  );
}
